import React from 'react';
import './ReportSteps.css';
import ScheduleZoneField, { defaultScheduleZone } from '../../shared/ScheduleZoneField';
import { formatScheduleTime } from '../../../../shared/datetime/timestamps';

const ReportStepSchedule = ({ formData, onSetFormData }) => {
  const trigger = formData.trigger ?? {};
  const frequency = trigger.frequency ?? 'daily';
  const time = trigger.time ?? '08:00';
  const dayOfWeek = trigger.dayOfWeek ?? 'monday';

  const handleFrequencyChange = (e) => {
    onSetFormData({
      ...formData,
      trigger: { ...trigger, frequency: e.target.value },
    });
  };

  const zone = formData.timezone || defaultScheduleZone();
  const timeDisplay = formatScheduleTime(time || '08:00', zone);

  return (
    <div className="report-step-content">
      <h3 className="report-step-title">Schedule</h3>

      <div className="report-form-field">
        <label className="report-label">Frequency</label>
        <div className="report-select-wrapper">
          <select
            className="resui-select report-select"
            value={frequency}
            onChange={handleFrequencyChange}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>
      </div>

      {frequency === 'monthly' && (
        <p className="report-helper">Reports run on the 1st of each month at the time selected below.</p>
      )}

      {frequency === 'weekly' && (
        <div className="report-form-field">
          <label className="report-label">Day of week</label>
          <select
            className="resui-select report-select"
            value={dayOfWeek}
            onChange={(e) =>
              onSetFormData({
                ...formData,
                trigger: { ...trigger, dayOfWeek: e.target.value },
              })
            }
          >
            <option value="monday">Monday</option>
            <option value="tuesday">Tuesday</option>
            <option value="wednesday">Wednesday</option>
            <option value="thursday">Thursday</option>
            <option value="friday">Friday</option>
            <option value="saturday">Saturday</option>
            <option value="sunday">Sunday</option>
          </select>
        </div>
      )}

      <div className="report-form-field">
        <label className="report-label">Time</label>
        <input
          type="time"
          className="resui-input report-time-input"
          value={time}
          onChange={(e) =>
            onSetFormData({
              ...formData,
              trigger: { ...trigger, time: e.target.value },
            })
          }
        />
        <span className="report-time-display">{timeDisplay}</span>
      </div>

      <ScheduleZoneField value={zone} onChange={(timezone) => onSetFormData({ ...formData, timezone })} />
    </div>
  );
};

export default ReportStepSchedule;
